export default "__VITE_ASSET__CJsZoI5v__"